// extracted by mini-css-extract-plugin
export default {"root_image_inner":"hangTypeForm_root_image_inner__0otDb"};